import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FullUpload from './FullUploadComponent';

const mapStateToProps = (state) => ({
  config: state.config,
  parentLocation: state.newProduct.parentLocation,
});

const mapDispatchToProps = () => ({});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(FullUpload);
